import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { CartProvider } from "@/lib/cart";
import { CompareProvider } from "@/lib/compare";
import ComparePage from "@/pages/Compare";
import { AuthProvider } from "@/lib/auth";
import ShopLayout from "@/components/shop/ShopLayout";
import Home from "@/pages/Home";
import BrandSeats from "@/pages/BrandSeats";
import SeatMakers from "@/pages/SeatMakers";
import Catalog from "@/pages/Catalog";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import SeatFinder from "@/pages/SeatFinder";
import PayOrder from "@/pages/PayOrder";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminOptions from "@/pages/admin/AdminOptions";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminPrivacy from "@/pages/admin/AdminPrivacy";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminCatalogOrder from "@/pages/admin/AdminCatalogOrder";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App grain">
      <LangProvider>
        <AuthProvider>
          <CartProvider>
          <CompareProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<ShopLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalog" element={<Catalog />} />
                  <Route path="/traktoriu-sedynes" element={<BrandSeats />} />
                  <Route path="/sedynes" element={<SeatMakers />} />
                  <Route path="/sedynes/:slug" element={<SeatMakers />} />
                  <Route path="/traktoriu-sedynes/:slug" element={<BrandSeats />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order/:id" element={<OrderSuccess />} />
                  <Route path="/pay/:id" element={<PayOrder />} />
                  <Route path="/seat-finder" element={<SeatFinder />} />
                  <Route path="/compare" element={<ComparePage />} />
                  <Route path="/privacy" element={<Legal doc="privacy" />} />
                  <Route path="/cookies" element={<Legal doc="cookies" />} />
                  <Route path="/terms" element={<Legal doc="terms" />} />
                  <Route path="/delivery" element={<Legal doc="delivery" />} />
                </Route>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="inquiries" element={<AdminInquiries />} />
                  <Route path="options" element={<AdminOptions />} />
                  <Route path="privacy" element={<AdminPrivacy />} />
                  <Route path="invoices" element={<AdminInvoices />} />
                  <Route path="catalog-order" element={<AdminCatalogOrder />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="top-right" />
          </CompareProvider>
          </CartProvider>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
